import { NumberFormatValueConverter } from '~/converters/number-format';

export class PercentFormatValueConverter extends NumberFormatValueConverter {
	constructor() {
		super('Percentage');
	}

	public toView(value, scale?) {
		return this.toViewPercentage(value, scale);
	}
}
